import {
  GET_VECTORS,
  GET_VECTORS_FAIL,
  GET_VECTORS_SUCCESS,
  GET_AUTH_USER,
  GET_AUTH_USER_FAIL,
  GET_AUTH_USER_SUCCESS,
  ADD_NEW_VECTOR,
  ADD_VECTOR_SUCCESS,
  ADD_VECTOR_FAIL,
  UPDATE_VECTOR,
  UPDATE_VECTOR_SUCCESS,
  UPDATE_VECTOR_FAIL,
  DELETE_VECTOR,
  DELETE_VECTOR_SUCCESS,
  DELETE_VECTOR_FAIL,
  GET_VECTOR_DETAIL,
} from "./actionTypes"

export const getVectors = page => ({
  type: GET_VECTORS,
  payload: page,

})

export const getVectorsSuccess = vectors => ({
  type: GET_VECTORS_SUCCESS,
  payload: vectors,
})

export const getVectorsFail = error => ({
  type: GET_VECTORS_FAIL,
  payload: error,
})

export const getAuthUsers = auth => ({
  type: GET_AUTH_USER,
  payload: auth,

})

export const getAuthUsersSuccess = auth => ({
  type: GET_AUTH_USER_SUCCESS,
  payload: auth,
})

export const getAuthUsersFail = error => ({
  type: GET_AUTH_USER_FAIL,
  payload: error,
})

export const addNewVector = quote => ({
  type: ADD_NEW_VECTOR,
  payload: quote,
})

export const addVectorSuccess = quote => ({
  type: ADD_VECTOR_SUCCESS,
  payload: quote,
})

export const addVectorFail = error => ({
  type: ADD_VECTOR_FAIL,
  payload: error,
})

export const updateVector = quote => ({
  type: UPDATE_VECTOR,
  payload: quote,
})

export const updateVectorSuccess = quote => ({
  type: UPDATE_VECTOR_SUCCESS,
  payload: quote,
})

export const updateVectorFail = error => ({
  type: UPDATE_VECTOR_FAIL,
  payload: error,
})

export const deleteVector = quote => ({
  type: DELETE_VECTOR,
  payload: quote,
})

export const deleteVectorSuccess = quote => ({
  type: DELETE_VECTOR_SUCCESS,
  payload: quote,
})

export const deleteVectorFail = error => ({
  type: DELETE_VECTOR_FAIL,
  payload: error,
})

export const getVectorDetails = quote => ({
  type: GET_VECTOR_DETAIL,
  payload: quote,
})

export const getVectorDetailFail = error => ({
  type: GET_VECTOR_DETAIL_FAIL,
  payload: error,
})


export const getVectorDetailSuccess = quote => ({
  type: GET_VECTOR_DETAIL_SUCCESS,
  payload: quote,
})


